export default function SolitaireIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <g transform="rotate(-14 26 40)">
        <rect x="8" y="14" width="28" height="40" rx="4" fill="#2F6FE8" stroke="#fff" strokeWidth="2.5" />
        <path d="M13 19l18 30M31 19L13 49" stroke="#8DB4FF" strokeWidth="2" />
      </g>
      <g transform="rotate(12 40 34)">
        <rect x="26" y="10" width="30" height="42" rx="4" fill="#fff" stroke="#1B2238" strokeWidth="2" />
        <text x="31" y="23" fontSize="11" fontWeight="900" fontFamily="Arial, sans-serif" fill="#D8263A">
          A
        </text>
        <path d="M41 26c-3-5-10-2-8 4 1 3 5 6 8 9 3-3 7-6 8-9 2-6-5-9-8-4z" fill="#D8263A" />
      </g>
    </svg>
  );
}
